import { useState } from "preact/hooks";
import { Route, Router, getCurrentUrl } from "preact-router";
import { scrollToHashElement, scrollToTop } from "./scrollToHash";
import namedRoutes from "../settings/routes";

import Header from "./header";
import Footer from "./footer";
// import Banner from "./banner";
// import Link from "./link";

import { PopupRoot } from "./popup/context";
import { PopupProvider } from "./popup/provider";

// Code-splitting is automated for routes
import Terms from "../routes/terms";
import Privacy from "../routes/privacy";
import Affiliate from "../routes/affiliate";
import Home from "../routes/home";
import About from "../routes/about";
import InventoryVanlife from "../routes/inventory-vanlife";
import PowerSystems from "../routes/power-systems";
import AlternatorChargers from "../routes/alternator-chargers";
import Deals from "../routes/deals";

import EcoflowVanlife from "../routes/ecoflow/vanlife";
import EcoflowAlternatorChargersGen2 from "../routes/ecoflow/alt-charger-gen2";
import EcoflowAlternatorChargersGen2Compatibility from "../routes/ecoflow/alt-charger-gen2/compatibility";
import EcoflowAlternatorChargersGen2CableGuide from "../routes/ecoflow/alt-charger-gen2/cableGuide";
import EcoflowAlternatorChargers from "../routes/ecoflow/alt-charger-gen1";
import EcoflowAlternatorChargersShort from "../routes/ecoflow/alt-charger-gen1/short";
import EcoflowAlternatorChargersInstall from "../routes/ecoflow/alt-charger-gen1/install";
import EcoflowAlternatorChargersGen1Compatibility from "../routes/ecoflow/alt-charger-gen1/compatibility";
import EcoflowAlternatorChargersGen1CableGuide from "../routes/ecoflow/alt-charger-gen1/cableGuide";
import EcoflowDeltaPro from "../routes/ecoflow/dp";
import EcoflowDeltaPro3 from "../routes/ecoflow/dp3";
import EcoflowDelta3Air from "../routes/ecoflow/d3-air";
import EcoflowDelta3MaxPlus from "../routes/ecoflow/delta-3-max-plus";
import EcoflowDelta3UltraPlus from "../routes/ecoflow/delta-3-ultra-plus";
import EcoflowDelta4Series from "../routes/ecoflow/delta-4-series";
import EcoflowTitanSeries from "../routes/ecoflow/titan-series";
import EcoflowBatteryCompatibility from "../routes/ecoflow/battery-compatibility";
import EcoflowWiring12v from "../routes/ecoflow/12v-wiring";
import EcoflowDeltaProUltraXt60Compatibility from "../routes/ecoflow/delta-pro-ultra/xt60-compatibility";

import BluettiVanlife from "../routes/bluetti/vanlife";
import BluettiRV5 from "../routes/bluetti/rv5";
import BluettiCharger2 from "../routes/bluetti/charger-2";
import BluettiCharger1 from "../routes/bluetti/charger-1/review";
import BluettiAC200L from "../routes/bluetti/ac200l";
import BluettiApex200 from "../routes/bluetti/apex-200";
import BluettiAlternatorChargersInstall from "../routes/bluetti/alternator-charger/install";
import BluettiCharger1Compatibility from "../routes/bluetti/charger-1/compatibility";
import BluettiCharger2Compatibility from "../routes/bluetti/charger-2/compatibility";

import JackeryVanlife from "../routes/jackery/vanlife";

import VelitHeater from "../routes/velit/heater";

import NotFound from "../routes/not-found";

const App = () => {
  let [currentUrl, setCurrentUrl] = useState(getCurrentUrl());

  if (typeof window !== "undefined") {
    // Prevent 404 pages from hydration errors
    if (document.body.hasAttribute("data-404")) {
      document.body.removeAttribute("data-404");
      const app = document.getElementById("app");
      if (app) {
        app.remove();
      }
    }
  }

  const handleRoute = async (e) => {
    setCurrentUrl(e.url);

    if (typeof window !== "undefined") {
      // Notify PopupProvider to run hidePopup()
      window.dispatchEvent(new CustomEvent("route-change"));

      if (
        e.url.includes("#") ||
        (window.location.hash && window.location.hash.length > 1)
      ) {
        scrollToHashElement(); // Not perfect: using 6 second of auto scrolling but browser 'find on page' can cause issues
      } else {
        scrollToTop();
      }
    }
  };

  return (
    <PopupProvider>
      <div id="app">
        <PopupRoot />

        <div id="app-content">
          {/* <Banner>
          <Link href="/#how-to-vote">Get your tickets</Link>
        </Banner> */}
          <Header />
          <main>
            <div class="wrapper">
              <Router url={currentUrl} onChange={handleRoute}>
                <Route component={Terms} path={namedRoutes.terms} />
                <Route component={Privacy} path={namedRoutes.privacy} />
                <Route component={Affiliate} path={namedRoutes.affiliate} />
                <Route component={Home} path={namedRoutes.home} />
                <Route component={About} path={namedRoutes.about} />
                <Route component={Deals} path={namedRoutes.deals} />
                <Route
                  component={InventoryVanlife}
                  path={namedRoutes.inventory.vanlife}
                />
                <Route
                  component={EcoflowVanlife}
                  path={namedRoutes.ecoflow.vanlife}
                />
                <Route
                  component={PowerSystems}
                  path={namedRoutes.powerSystems}
                />
                <Route
                  component={AlternatorChargers}
                  path={namedRoutes.alternatorChargers}
                />
                <Route
                  component={EcoflowAlternatorChargersGen1Compatibility}
                  path={namedRoutes.ecoflow.altCharger.gen1Compatibility}
                />
                <Route
                  component={EcoflowAlternatorChargersGen1CableGuide}
                  path={namedRoutes.ecoflow.altCharger.gen1CableGuide}
                />
                <Route
                  component={EcoflowAlternatorChargersGen2}
                  path={namedRoutes.ecoflow.altCharger.gen2}
                />
                <Route
                  component={EcoflowAlternatorChargersGen2Compatibility}
                  path={namedRoutes.ecoflow.altCharger.gen2Compatibility}
                />
                <Route
                  component={EcoflowAlternatorChargersGen2CableGuide}
                  path={namedRoutes.ecoflow.altCharger.gen2CableGuide}
                />
                <Route
                  component={EcoflowDeltaPro}
                  path={namedRoutes.ecoflow.dp}
                />
                <Route
                  component={EcoflowDeltaPro3}
                  path={namedRoutes.ecoflow.dp3}
                />
                <Route
                  component={EcoflowDelta3Air}
                  path={namedRoutes.ecoflow.d3air}
                />
                <Route
                  component={EcoflowDelta3MaxPlus}
                  path={namedRoutes.ecoflow.d3maxPlus}
                />
                <Route
                  component={EcoflowDelta3UltraPlus}
                  path={namedRoutes.ecoflow.d3ultraPlus}
                />
                <Route
                  component={EcoflowDelta4Series}
                  path={namedRoutes.ecoflow.delta4.series}
                />
                <Route
                  component={EcoflowTitanSeries}
                  path={namedRoutes.ecoflow.titanSeries}
                />
                <Route
                  component={EcoflowAlternatorChargersShort}
                  path={namedRoutes.ecoflow.altCharger.quick}
                />
                <Route
                  component={EcoflowAlternatorChargers}
                  path={namedRoutes.ecoflow.altCharger.review}
                />
                <Route
                  component={EcoflowAlternatorChargersInstall}
                  path={namedRoutes.ecoflow.altCharger.transit}
                />
                <Route
                  component={EcoflowBatteryCompatibility}
                  path={namedRoutes.ecoflow.batteryCompatibility}
                />
                <Route
                  component={EcoflowWiring12v}
                  path={namedRoutes.ecoflow.wiring12v}
                />
                <Route
                  component={EcoflowDeltaProUltraXt60Compatibility}
                  path={namedRoutes.ecoflow.deltaProUltra.xt60Compatibility}
                />

                <Route
                  component={BluettiVanlife}
                  path={namedRoutes.bluetti.vanlife}
                />
                <Route
                  component={BluettiCharger2}
                  path={namedRoutes.bluetti.charger2.review}
                />
                <Route
                  component={BluettiCharger1}
                  path={namedRoutes.bluetti.charger1.review}
                />
                <Route
                  component={BluettiAlternatorChargersInstall}
                  path={namedRoutes.bluetti.altCharger.transit}
                />
                <Route
                  component={BluettiCharger1Compatibility}
                  path={namedRoutes.bluetti.charger1.compatibility}
                />
                <Route
                  component={BluettiCharger2Compatibility}
                  path={namedRoutes.bluetti.charger2.compatibility}
                />
                <Route component={BluettiRV5} path={namedRoutes.bluetti.rv5} />
                <Route
                  component={BluettiAC200L}
                  path={namedRoutes.bluetti.ac200l}
                />
                <Route
                  component={BluettiApex200}
                  path={namedRoutes.bluetti.apex200}
                />

                <Route
                  component={JackeryVanlife}
                  path={namedRoutes.jackery.vanlife}
                />

                <Route
                  component={VelitHeater}
                  path={namedRoutes.velit.heater}
                />
                <Route component={NotFound} default />
              </Router>
            </div>
          </main>
          <Footer />
        </div>
      </div>
    </PopupProvider>
  );
};

export default App;
